export const AUTH_PLACEHOLDERS = {
  account: "0969686869 hoặc email@example.com",
  phone: "0969686869",
  fullName: "Nguyễn Minh Anh",
  password: "Ví dụ: Password123",
  otp: "888888",
} as const;

export const AUTH_COPY = {
  passwordHint: "Mật khẩu từ 6 đến 20 ký tự, có chữ hoa, chữ thường và chữ số.",
  forgotPasswordDescription:
    "Nhập email hoặc số điện thoại đã đăng ký để nhận mã OTP đặt lại mật khẩu.",
  resetPasswordSuccess: "Mật khẩu đã được cập nhật. Bạn có thể đăng nhập lại.",
} as const;

export const AUTH_QUERY = {
  MODE: "mode",
} as const;

export const AUTH_MODE = {
  OTP: "otp",
  PASSWORD: "password",
} as const;

export const AUTH_MOCK = {
  loginOtp: "888888",
  resetOtp: "888888",
  resetExpiresInMinutes: 10,
  requestDelay: 450,
  resendCooldownSeconds: 30,
  googleAccessToken: "mock-google-access-token",
} as const;

export const REQUIRED_RECAPTCHA_ERROR_CODES = [
  "RECAPTCHA_REQUIRED",
  "REQUIRED_CAPTCHA",
] as const;

export const RECAPTCHA_REQUIRED_MESSAGE =
  "Vui lòng xác minh rằng bạn không phải robot.";

export const RECAPTCHA_MISSING_SITE_KEY_MESSAGE =
  "reCAPTCHA chưa được cấu hình. Vui lòng thử lại sau.";

export const CUSTOMER_AUTH_RECAPTCHA_ACTIONS = {
  SEND_LOGIN_OTP: "customer_send_login_otp",
  VERIFY_LOGIN_OTP: "customer_verify_login_otp",
  RESEND_LOGIN_OTP: "customer_resend_login_otp",
  LOGIN_WITH_PASSWORD: "customer_login_with_password",
  SEND_GOOGLE_PHONE_OTP: "customer_send_google_phone_otp",
  VERIFY_GOOGLE_PHONE_OTP: "customer_verify_google_phone_otp",
  RESEND_GOOGLE_PHONE_OTP: "customer_resend_google_phone_otp",
} as const;

export const CUSTOMER_AUTH_RECAPTCHA_STEP_ACTIONS = {
  PHONE_ENTRY: [CUSTOMER_AUTH_RECAPTCHA_ACTIONS.SEND_LOGIN_OTP],
  OTP: [
    CUSTOMER_AUTH_RECAPTCHA_ACTIONS.VERIFY_LOGIN_OTP,
    CUSTOMER_AUTH_RECAPTCHA_ACTIONS.RESEND_LOGIN_OTP,
  ],
  PASSWORD_ENTRY: [CUSTOMER_AUTH_RECAPTCHA_ACTIONS.LOGIN_WITH_PASSWORD],
  GOOGLE_PHONE_ENTRY: [CUSTOMER_AUTH_RECAPTCHA_ACTIONS.SEND_GOOGLE_PHONE_OTP],
  GOOGLE_PHONE_OTP: [
    CUSTOMER_AUTH_RECAPTCHA_ACTIONS.VERIFY_GOOGLE_PHONE_OTP,
    CUSTOMER_AUTH_RECAPTCHA_ACTIONS.RESEND_GOOGLE_PHONE_OTP,
  ],
} as const;

export const CUSTOMER_AUTH_RECAPTCHA_FLOW_ACTIONS = [
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.SEND_LOGIN_OTP,
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.VERIFY_LOGIN_OTP,
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.RESEND_LOGIN_OTP,
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.LOGIN_WITH_PASSWORD,
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.SEND_GOOGLE_PHONE_OTP,
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.VERIFY_GOOGLE_PHONE_OTP,
  CUSTOMER_AUTH_RECAPTCHA_ACTIONS.RESEND_GOOGLE_PHONE_OTP,
] as const;

export const FORGOT_PASSWORD_RECAPTCHA_ACTIONS = {
  REQUEST_OTP: "customer_forgot_password_request_otp",
  VERIFY_OTP: "customer_forgot_password_verify_otp",
  RESEND_OTP: "customer_forgot_password_resend_otp",
  RESET_PASSWORD: "customer_forgot_password_reset_password",
} as const;

export const FORGOT_PASSWORD_RECAPTCHA_STEP_ACTIONS = {
  REQUEST: [FORGOT_PASSWORD_RECAPTCHA_ACTIONS.REQUEST_OTP],
  OTP: [
    FORGOT_PASSWORD_RECAPTCHA_ACTIONS.VERIFY_OTP,
    FORGOT_PASSWORD_RECAPTCHA_ACTIONS.RESEND_OTP,
  ],
  RESET: [FORGOT_PASSWORD_RECAPTCHA_ACTIONS.RESET_PASSWORD],
} as const;

export const FORGOT_PASSWORD_RECAPTCHA_FLOW_ACTIONS = [
  FORGOT_PASSWORD_RECAPTCHA_ACTIONS.REQUEST_OTP,
  FORGOT_PASSWORD_RECAPTCHA_ACTIONS.VERIFY_OTP,
  FORGOT_PASSWORD_RECAPTCHA_ACTIONS.RESEND_OTP,
  FORGOT_PASSWORD_RECAPTCHA_ACTIONS.RESET_PASSWORD,
] as const;
